<!--
 * @Author: 王鹏
 * @Date: 2020-08-29 12:57:59
 * @LastEditors: wp
 * @LastEditTime: 2020-08-29 14:58:48
 * @FilePath: \web\src\App.vue
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import "@/assets/css/all.css";
import "@/assets/css/base.css";
export default {
  name: "app",
  data() {
    return {};
  },
};
</script>

<style>
#app {
  background-color: #e9ebec;
}
</style>
